var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantageIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    viewBox: "0 0 44 36",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.65 36c-.4 0-.75-.15-1.05-.45s-.45-.65-.45-1.05v-2.1h-.65c-1.52767 0-2.82633-.5347-3.896-1.604-1.069333-1.0697-1.604-2.3683-1.604-3.896v-12.2c0-1.7.516667-2.9917 1.55-3.875 1.03333-.88333 2.25-1.325 3.65-1.325v-4.3c0-1.53333.48333-2.78333 1.45-3.75.96667-.966667 2.21667-1.45 3.75-1.45h23.25c1.5333 0 2.775.483333 3.725 1.45.95.96667 1.425 2.21667 1.425 3.75v4.3c1.4 0 2.6167.44167 3.65 1.325 1.0333.8833 1.55 2.175 1.55 3.875v12.2c0 1.5277-.5347 2.8263-1.604 3.896-1.0697 1.0693-2.3683 1.604-3.896 1.604h-.65v2.1c0 .4-.15.75-.45 1.05s-.65.45-1.05.45-.75-.15-1.05-.45-.45-.65-.45-1.05v-2.1h-25.7v2.1c0 .4-.15.75-.45 1.05s-.65.45-1.05.45zm-2.15-6.6h33c.6667 0 1.25-.25 1.75-.75s.75-1.0833.75-1.75v-12.2c0-.6667-.2-1.2-.6-1.6s-.9333-.6-1.6-.6-1.2.2-1.6.6-.6.9333-.6 1.6v8.8h-29.2v-8.8c0-.6667-.2-1.2-.6-1.6s-.93333-.6-1.6-.6-1.2.2-1.6.6-.6.9333-.6 1.6v12.2c0 .6667.25 1.25.75 1.75s1.08333.75 1.75.75zm4.9-8.9h23.2v-5.8c0-1.0333.2333-1.8917.7-2.575s.9667-1.225 1.5-1.625v-5.3c0-.66667-.2-1.2-.6-1.6s-.929-.6-1.587-.6h-23.226c-.658 0-1.187.2-1.587.6s-.6.93333-.6 1.6v5.3c.53333.4 1.03333.9417 1.5 1.625.4667.6833.7 1.5417.7 2.575z",
    fill: "#fcc241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantageIcon5);
export default __webpack_public_path__ + "static/media/advantage-icon-5.737ca63de9f01a79234f841a2328fdc9.svg";
export { ForwardRef as ReactComponent };